import { Player } from '@lc/interface/player/types';
import { energyColors } from '@lc/types/Misc';

export default class PlayerAction {
	buyBattery(player: Player, numBatteries: number = 1) {
		const currBatteries = player.batteries;
		const newBatteries = Math.min(player.batteries + numBatteries, 6);
		player.batteries = newBatteries;
		player.batteriesBuiltThisSeason += newBatteries - currBatteries;
	}

	buyFactory(player: Player, numFactories: number = 1) {
		const currFactories = player.factories;
		const newFactories = Math.min(player.factories + numFactories, 6);
		player.factories = newFactories;
		player.factoriesBuiltThisSeason += newFactories - currFactories;
	}

	buyPR(player: Player, energyColors: energyColors[]) {
		// determine which colors will be added via frontend request (or intermediary action?)
		for (const energyColor of energyColors) {
			player.prArr.push(energyColor);
		}
	}

	deleteBattery(player: Player, numBatteries: number = 1) {
		player.batteries -= numBatteries;
		if (player.batteries < 0) player.batteries = 0;

		while (player.batteryEnergyArr.length > player.batteries) {
			player.batteryEnergyArr.pop();
		}

		player.batteriesBuiltThisSeason -= numBatteries;
	}

	deleteFactory(player: Player, numFactories: number = 1) {
		player.factories -= numFactories;
		if (player.factories < 0) player.factories = 0;

		while (player.factoryEnergyArr.length > player.factories) {
			player.factoryEnergyArr.pop();
		}

		player.factoriesBuiltThisSeason -= numFactories;
	}

	donateEnergy(
		player: Player,
		paymentObject: {
			factoryEnergyArr: string[];
			batteryEnergyArr: string[];
		}
	) {
		if (
			!paymentObject ||
			!paymentObject.factoryEnergyArr ||
			!paymentObject.batteryEnergyArr
		) {
			return;
		}
		for (const e of paymentObject.factoryEnergyArr) {
			player.donationCupArr.push(e);
		}

		for (const e of paymentObject.batteryEnergyArr) {
			player.donationCupArr.push(e);
		}
	}

	donateSingleEnergy(player: Player) {
		player.donationCupArr.push(player.energyColor);
	}

	getPrLen(player: Player) {
		return player.prArr.length;
	}

	removeDonation(player: Player, numRemove = 1) {
		while (numRemove > 0) {
			player.donationCupArr.pop();
			numRemove--;
		}
	}

	refillFactories(
		player: Player,
		energyColor: energyColors = player.energyColor
	) {
		// ALWAYS HAPPENS WHEN NEWS CARD FLIPS, THEN THIS AMOUNT IS MODIFIED
		player.factoryEnergyArr = []; // delete all remaining energy on factories

		for (let i = 0; i < player.factories; i++) {
			player.factoryEnergyArr.push(energyColor);
		}

		if (player.factories < 2) {
			player.factories = 2;
		}
	}

	refillBattery(
		player: Player,
		energyColor: energyColors = player.energyColor
	) {
		if (player.batteryEnergyArr.length < player.batteries) {
			player.batteryEnergyArr.push(energyColor);
		}
	}

	refillAllBatteries(player: Player, energyColor = player.energyColor) {
		// ALWAYS HAPPENS WHEN NEWS CARD FLIPS, THEN THIS AMOUNT IS MODIFIED
		while (player.batteryEnergyArr.length < player.batteries) {
			player.batteryEnergyArr.push(energyColor);
		}
	}

	// attempts to take numEnergy from player's factories and batteries (factories first, then batteries), returns array of chars indicating energy taken
	stealEnergy(player: Player, numEnergy: number = 1) {
		const energyTally: string[] = [];

		while (player.factoryEnergyArr.length > 0 && numEnergy > 0) {
			const e = player.factoryEnergyArr.pop();
			if (e) energyTally.push(e);
			numEnergy--;
		}

		if (numEnergy === 0) return energyTally;

		while (player.batteryEnergyArr.length > 0 && numEnergy > 0) {
			const e = player.batteryEnergyArr.pop();
			if (e) energyTally.push(e);
			numEnergy--;
		}

		return energyTally;
	}

	storeEnergy(player: Player) {
		if (
			player.factoryEnergyArr.length > 0 &&
			player.batteryEnergyArr.length < player.batteries
		) {
			const fe = player.factoryEnergyArr.pop();
			if (fe) {
				player.batteryEnergyArr.push(fe);
				return true;
			}
		}
		return false;
	}

	/** TODOTODO
	 * tests all player's summit cards. If one reaches the condition to be played, return true
	 * @param player
	 * @returns
	 */
	atLeastOneSummitCardPlayable(player: Player) {
		return true;
	}
}

export const act_player = new PlayerAction();
